import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useSubscriptionMonitor from "../hooks/useSubscriptionMonitor";
import { useDispatch, useSelector } from "react-redux";
import {
  discoveryBrandsParamsSelector,
  discoveryBrandsSelector,
} from "../store/discovery/selector";
import { userDetailsSelector } from "../store/account/selector";
import { MetaDataSagaActions } from "../store/metadata/sagas";
import { DashoardAnalyticsSagaActions } from "../store/dashboardAnalytics/sagas";
import { DiscoverySagaActions } from "../store/discovery/sagas";
import { useEffect } from "react";
import {DashoardAnalyticsReducerAction} from "../store/dashboardAnalytics/slice";
import {MetaDataReducerAction} from "../store/metadata/slice";
import {DiscoveryReducerAction} from "../store/discovery/slice";

const GuestGuard = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, isPathNameFolder } = useAuth();

  // Add subscription monitoring to check for plan expiry
  useSubscriptionMonitor();

  const searchParms = new URLSearchParams(location.search);
  const next = searchParms.get("next");
  const userDetails = useSelector(userDetailsSelector);
  const discoveryBrandLists = useSelector(discoveryBrandsSelector);
  const discoveryBrandsParams = useSelector(discoveryBrandsParamsSelector);
  const isInvitedUserAccesible = userDetails?.isInvitedUserAccesible;
  const isInvitePending =
    userDetails?.isInvitedBySeat === "PENDING" && !isInvitedUserAccesible;

  useEffect(() => {
    if (userDetails?._id) {
      if (userDetails?.planId || isInvitedUserAccesible) {
        dispatch(DashoardAnalyticsReducerAction.setDashboardLoadingState(true));
        dispatch(MetaDataReducerAction.resetSwipefileState());
        dispatch(DiscoveryReducerAction.resetDiscoveryState());
        dispatch(MetaDataSagaActions.fetchFavouriteBrands());
        dispatch(DashoardAnalyticsSagaActions.fetchDashboardAnalyticsData());
        dispatch(MetaDataSagaActions.fetchTagLists());
        dispatch(MetaDataSagaActions.fetchBoardList());
        dispatch(DiscoverySagaActions.fetchDiscoveryList());
        if (discoveryBrandLists?.data?.length === 0) {
          dispatch(
            DiscoverySagaActions.fetchDiscoveryTopBrandList(
              discoveryBrandsParams
            )
          );
        }
        dispatch(MetaDataSagaActions.teamDetails());
      } else {
        if (isInvitePending) {
          navigate("/invited-member");
        } else {
          navigate("/subscription");
        }
      }
    }
  }, [userDetails]);

  return isAuthenticated || isPathNameFolder ? (
    <Outlet />
  ) : (
    <Navigate
      to={`/landing-page${
        location.pathname
          ? "?next=" +
            (next ||
              encodeURIComponent(window.location.origin + location.pathname))
          : ""
      }`}
      state={{ from: location }}
      replace
    />
  );
};

export default GuestGuard;
